var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.text
        ? [
            _c(
              "div",
              { staticClass: "d-flex align-center" },
              [
                _vm.hasIconForText
                  ? _c("icon-svg", {
                      staticClass: "mr-1",
                      attrs: {
                        name: _vm.icon,
                        size: "14",
                        color: _vm.computedColor
                      }
                    })
                  : _c("div", {
                      staticClass: "status-dot mr-1",
                      style: { backgroundColor: _vm.computedColor }
                    }),
                _c(
                  "span",
                  {
                    staticClass: "status-text",
                    class: { "status-text--preserve-case": _vm.preserveCase },
                    style: { color: _vm.computedColor }
                  },
                  [_vm._v(" " + _vm._s(_vm.displayContent) + " ")]
                )
              ],
              1
            )
          ]
        : _vm.soft
        ? [
            _c(
              "div",
              {
                staticClass:
                  "status-chip status-chip--soft d-inline-flex align-center",
                style: { "--status-color": _vm.cssColor }
              },
              [
                _c("div", { staticClass: "status-dot status-dot--soft mr-1" }),
                _c(
                  "span",
                  {
                    staticClass: "status-label status-label--soft",
                    class: { "status-label--preserve-case": _vm.preserveCase }
                  },
                  [_vm._v(" " + _vm._s(_vm.displayContent) + " ")]
                )
              ]
            )
          ]
        : [
            _c(
              "div",
              { staticClass: "status-chip d-inline-flex align-center" },
              [
                _vm.hasIcon
                  ? _c("icon-svg", {
                      staticClass: "mr-1",
                      attrs: {
                        name: _vm.computedIcon,
                        size: "15",
                        color: _vm.computedColor
                      }
                    })
                  : _vm._e(),
                _c(
                  "span",
                  {
                    class: [
                      _vm.statusLabelClass,
                      "status-label",
                      { "status-label--preserve-case": _vm.preserveCase }
                    ]
                  },
                  [_vm._v(" " + _vm._s(_vm.displayContent) + " ")]
                )
              ],
              1
            )
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }